import { QueryClient } from "@tanstack/query-core";
import { useIsFetching as useIsRQFetching } from "@tanstack/react-query";
const w = window;
export function getQueryClient() {
    if (!w.qc) {
        w.qc = new QueryClient();
    }
    return w.qc;
}
/**
 * @deprecated
 * Prefer use of hook, used only in the shell, will be removed in the future
 */
export function getWithCache(endpoint, token, options) {
    const queryClient = getQueryClient();
    return queryClient.fetchQuery({
        queryKey: getQueryKey(new URL(endpoint)),
        queryFn: () => get(endpoint, token, options),
        ...options,
    });
}
export const clearCache = () => {
    getQueryClient().clear();
    console.log("Request cache cleared.");
};
export async function get(endpoint, token, fetchOption = {}) {
    const { headers: extraHeaders, cache, credentials } = fetchOption;
    const res = await window.fetch(endpoint, {
        headers: {
            Accept: "application/json",
            ...(fetchOption.useToken ? { authorization: `Bearer ${token}` } : {}),
            ...extraHeaders,
        },
        ...(credentials ? { credentials } : {}),
        ...(cache ? { cache } : {}),
    });
    if (!res.ok)
        throw res;
    return res.json();
}
export const getUrl = (url, queryParams) => {
    const newUrl = new URL(url);
    if (queryParams) {
        (queryParams instanceof URLSearchParams
            ? Array.from(queryParams.entries())
            : Object.entries(queryParams)).forEach(([key, value]) => (Array.isArray(value) ? value : [value]).forEach((v) => newUrl.searchParams.append(key, `${v}`)));
    }
    return newUrl;
};
export const getQueryKey = (url, ignoreParams) => [
    url.host,
    url.pathname,
    Object.fromEntries(Array.from(url.searchParams.entries()).filter(([key]) => !ignoreParams?.includes(key))),
];
export const useIsFetching = (url) => {
    return useIsRQFetching(url ? { queryKey: getQueryKey(new URL(url)) } : undefined);
};
